<template>
    <div>
        <div class="card shadow p-0 m-0">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.subscribers', 2) }}
                    </h3>
                </div>
            </div>

           
            <b-container class="p-0">
                <div class="card-title">
                    <router-link :to="{ name: 'add-subscriber' }" v-if="can || hasAssistante">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>
                <b-row class="justify-content-sm-center p-0 m-0">
                    <b-col col sm="12" class="p-0">
                        <!--                                <b-form-group>-->
                        <div class="vgt-global-search vgt-clearfix">
                            <div class="vgt-global-search__input vgt-pull-left"><span class="input__icon">
                                <div class="magnifying-glass">

                                </div>
                            </span>
                                <input type="text" placeholder="Search user" class="vgt-input vgt-pull-left" v-model="searchTerm">
                            </div>
                            <!-- <div class="vgt-global-search__actions vgt-pull-right">

                            </div> -->
                        </div>
                        <vue-good-table
                            id="operation"
                            :columns="mSubscribersColumns"
                            :rows="mSubscribersFilter"
                            :search-options="{
                            enabled:true,
                            externalQuery: searchTerm
                            }"
                            :pagination-options="paginationOptions"
                            @on-row-click="mSubscriberClick"/>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Subscribers",

        computed: {
            ...mapGetters(["subscribers",'hasAdminRole',
                'hasGestionnaireRole',
                'hasPraticienRole',
                'hasMedecinControleRole',
                'hasAssistante'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            mSubscribers: function() {
                let sArray = [];

                _.forEach(_.orderBy(this.subscribers,['created_at'],['desc']), function(subscriber) {
                    let s = {};

                    if((typeof subscriber.user == 'object') && (!_.isNull(subscriber.user))) {
                        let prenom = subscriber.user.prenom ? subscriber.user.prenom : '';
                        prenom =  prenom.toLowerCase();
                        s.nom =  (subscriber.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        s.email = subscriber.user.email;
                        s.telephone = subscriber.user.telephone;
                        s.nationalite = subscriber.user.nationalite;
                        s.sexe = subscriber.sexe;
                        s.ville = subscriber.user.ville;
                        s.pays = subscriber.user.pays;
                        s.date = moment(subscriber.date_de_naissance).format('DD-MM-YYYY');
                        s.id = subscriber.user.id;
                        s.slug = subscriber.user.slug;
                        s.adresse = subscriber.user.adresse;

                    }

                    sArray.push(s);
                });

                return sArray;
            },

            rows: function() {
                return this.mSubscribers.length;
            }
        },

        data() {
            return {
                mSubscribersFilter:[],
                searchTerm : '',
                mSubscribersColumns: [
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email'),
                    },
                    {
                        field: 'telephone',
                        label: this.$i18n.t('message.phoneNumber'),
                    },
                    {
                        field: 'nationalite',
                        label: this.$i18n.t('message.nationality'),
                    },
                    /*{
                        key: 'sexe',
                        label: this.$i18n.t('message.gender'),
                    },
                    {
                        key: 'ville',
                        label: this.$i18n.tc('message.cities', 1),
                    },
                    {
                        key: 'pays',
                        label: this.$i18n.tc('message.countries', 1),
                    },*/
                    {
                        field: 'adresse',
                        label: this.$i18n.t('message.address'),
                        sortable: true
                    },
                    // {
                    //     key: 'action',
                    //     label: this.$i18n.tc('message.operations', 1)
                    // }
                ],
                offset: 0,
                limit: -1,
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
            }
        },
        watch:{
            searchTerm:function (newValue, oldValue) {
                if (this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante){
                    if (newValue.trim().length ==0){
                        this.mSubscribersFilter = [];
                    }else{
                        this.mSubscribersFilter = this.mSubscribers;
                    }
                }
            }
        },
        methods: {
            getSubscribers() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getSubscribers', { args : args });
            },

            mSubscriberClick(params){
                this.$router.push({ name: 'subscriber', params: { subscriber: params.row.slug } });
            },

            deleteSubscriber(subscriber) {
                let self = this;

                let args = {
                    subscriber: subscriber
                };

                let successMessage = this.$i18n.t('message.subscriberDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteSubscriber', { args, index: subscriber, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + subscriber);
                    });
            }
        },

        mounted() {
            // Fetch subscriber list
            this.getSubscribers();
        }
    }
</script>

<style scoped>

</style>